<template>
  <b-card bg-variant="light"
          class="ml-3 mr-3"
          header="Rapid access technical evaluation"
          header-bg-variant="dark"
          header-text-variant="white">

    <b-tabs v-model="selectedTab"
            card>
      <b-tab active
             class="pl-0 pr-0"
             title="Technical evaluation">
        <b-row no-gutters>
          <b-col class="text-right">
            <button-spinner :loading="zipLoading"
                            class="mb-2"
                            variant="info"
                            @click="downloadZipWrapper">
              <template v-slot:defaultText>
                <span>PROPOSALS TO ZIP ({{ buttonZipTextAppend }})</span>
              </template>
            </button-spinner>
          </b-col>
        </b-row>
        <rapid-access-technical-evaluation-tab
          :proposals="proposals"
          :proposals-loading="proposalsLoading"
          @filtered-proposals="filteredProposals"
          @update-proposals="updateProposals"/>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
  import ButtonSpinner from '@/components/buttonSpinner';
  import RapidAccessTechnicalEvaluationTab
    from '@/components/evaluation/rapid-access/technical/RapidAccessTechnicalEvaluationTab';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { rapidAccessTechnicalEvaluation as urlLayer } from '@/api/url_layer';

  export default {
    name: 'RapidAccessTechnicalEvaluationDashboard',
    components: { ButtonSpinner, RapidAccessTechnicalEvaluationTab },
    mixins: [infrastructureMixin],
    data() {
      return {
        proposals: [],
        selectedTab: 0,
        proposalsLoading: false,
        zipLoading: false,

        // use to handle zip filtered proposals
        filteredProposalsList: null,
        buttonZipTextAppend: 'ALL',

      };
    },
    methods: {
      async loadProposals(infrastructure) {
        this.proposalsLoading = true;
        try {
          const response = await urlLayer.loadRapidAccessTechnicalEvaluationProposals(infrastructure);
          if (response.status === 204) {
            this.$notify({ type: 'warn', title: 'No proposals to load!' });
          } else {
            this.$notify({ type: 'success', title: 'Proposals loaded successfully!' });
          }
          this.proposals = response.data.proposals;
        } catch (error) {
          this.$notify({ type: 'error', title: error.response.data });
        } finally {
          this.proposalsLoading = false;
        }
      },
      filteredProposals(proposals) {
        this.filteredProposalsList = proposals;
        this.updateButtonZipTextAppend();
      },
      async downloadZipWrapper() {
        this.zipLoading = true;
        const params = [];

        // eslint-disable-next-line camelcase
        params.push({ proposal_id_range: this.filteredProposalIDRange(this.filteredProposalsList) });

        await this.downloadZip(...params);
        this.zipLoading = false;
      },
      updateProposals(updatedProposal) {
        for (let i = 0; i < this.proposals.length; i += 1) {
          if (this.getId(this.proposals[i]) === this.getId(updatedProposal)) {
            this.$set(this.proposals, i, updatedProposal);
          }
        }
      },
      updateButtonZipTextAppend() {
        const filteredProposalsLength = this.filteredProposalsList?.length;
        const allProposalsLength = this.proposals?.length;
        this.buttonZipTextAppend = allProposalsLength === filteredProposalsLength ? 'ALL'
          : filteredProposalsLength.toString();
      },
      filteredProposalIDRange(documents) {
        const uniqueProposalIds = new Set();
        documents.forEach((obj) => {
          uniqueProposalIds.add(obj.document_specification?.document_id);
        });
        return Array.from(uniqueProposalIds);
      },
    },
    watch: {
      proposals() {
        if (!this.filteredProposalsList) {
          this.filteredProposalsList = this.proposals;
        }
        this.updateButtonZipTextAppend();
      },
    },
    created() {
      this.loadProposals(this.infrastructure);
    },
  };
</script>
